module.exports = __webpack_public_path__ + "img/aw.c7cc0c4c.svg";